module.exports = __webpack_public_path__ + "img/banner1_9.af5fbb32.png";